'use strict';

module.exports = {
    sfcpUpdateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            var $productContainer = response.$productContainer;
            var $button = $productContainer.find('.salesforce-buynow-element');

            if ($button && $button.length) {
                $button.attr('disabled',
                    (!response.product.readyToOrder || !response.product.available));
            }
        });
    },
};
